import styled, { css } from 'styled-components';

export const JobMapMediaContainer = styled.div`
  ${(props) =>
    props.imageUrl &&
    css`
      height: 180px;
      background-image: url('${props.imageUrl}');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    `}
`;

export default JobMapMediaContainer;
